<td *transloco="let t">
  <img src="assets/img/logo/iSophi_rastr_dark.png" alt="logo" />
  <span class="mx-3">//</span><span [innerHTML]="t('footer/domain')"></span>
</td>
